<template>
  <div>
    <div class="control-section accordion-icons">
      <h3>Documents</h3>
      <ejs-button type="button" cssClass="e-info" v-on:click.native="addDocument">
        <font-awesome-icon :icon="['fas', 'plus']" style="display: inline" />
        Add Documents
      </ejs-button>
      <br />
      <br />
      <ejs-grid
        :dataSource="documents"
        :selection-settings="selectionOptions"
        :commandClick="commandClick"
        :allowSorting="true"
        :allowPaging="true"
        :pageSettings="gridPageSettings"
        :actionComplete="onGridLoadComplete"
      >
        <e-columns>
          <e-column
            field="documentId"
            headerText="documentId"
            textAlign="Right"
            :isPrimaryKey="true"
            width="0"
          ></e-column>
          <e-column field="documentName" headerText="Document Name"></e-column>
          <e-column field="createUser" headerText="Created By" textAlign="Left"></e-column>
          <e-column
            field="createDate"
            headerText="Created On"
            textAlign="Left"
            type="date"
            format="MMM dd, yyyy"
          ></e-column>
          <e-column headerText="Commands" :commands="commands"></e-column>
        </e-columns>
      </ejs-grid>

      <forms-category-document-modal
        key="formsCategoryDocumentRef"
        ref="formsCategoryDocumentRef"
        :data="selectedDocument"
        :visible="isModalVisible"
      />

      <div ref="spinnerEle" id="spinner"></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import {
  GridPlugin, Page, Toolbar, Edit, CommandColumn,
} from "@syncfusion/ej2-vue-grids";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { DialogUtility } from "@syncfusion/ej2-popups";

import {
  FETCH_FORMS_CATEGORY_DOCUMENTS,
  SET_SELECTED_FORMS_CATEGORY_DOCUMENT,
  DELETE_FORMS_CATEGORY_DOCUMENT,
} from "../store";

import FormsCategoryDocumentModal from "../components/forms-category-document-modal.vue";
import { getDocument } from "../services/forms-api";

Vue.use(DialogPlugin);
Vue.use(ButtonPlugin);
Vue.use(GridPlugin);

let DialogObj;

export default {
  name: "FormsCategoryDocuments",
  components: { FormsCategoryDocumentModal },
  data() {
    return {
      isModalVisible: false,
      selectionOptions: {
        type: "Single",
        enableSimpleMultiRowSelection: false,
        enableToggle: true,
        persistSelection: true,
      },
      gridPageSettings: { pageSize: 10 },
      editSettings: { allowEditing: true, allowDeleting: true },
      commands: [
        {
          type: "Download",
          buttonOption: { cssClass: "e-flat", iconCss: "e-download e-icons" },
        },
        // {
        //   type: "Edit",
        //   buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" },
        // },
        {
          type: "Delete",
          buttonOption: { cssClass: "e-flat", iconCss: "e-delete e-icons" },
        },
      ],
    };
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn],
  },
  async created() {
    await this.initialize();
  },
  mounted() {},
  computed: {
    ...mapGetters({
      documents: "documents",
      selectedDocument: "selectedDocument",
      loggedUser: "loggedUser",
    }),
    loggedUserId() {
      return this.loggedUser?.id;
    },
    categories() {
      return this.$store.getters.category;
    },
  },
  watch: {},
  methods: {
    onGridLoadComplete() {
      this.$refs.spinnerEle.style.display = "none";
    },
    async initialize() {
      await this.$store.dispatch(FETCH_FORMS_CATEGORY_DOCUMENTS, this.$route.params.category);
    },
    async addDocument() {
      await this.$store.dispatch(SET_SELECTED_FORMS_CATEGORY_DOCUMENT, {
        documentType: null,
        documentName: null,
        documentContent: null,
      });

      this.$refs.formsCategoryDocumentRef.$refs.AddEditFormsCategoryDocumentRef.$children[1].resetModal();
      this.$refs.formsCategoryDocumentRef.$refs.AddEditFormsCategoryDocumentRef.show();
    },
    commandClick(args) {
      if (args.commandColumn.type === "Edit") {
        this.setEditModalValues(args.rowData);
      } else if (args.commandColumn.type === "Delete") {
        this.deleteDocument(args.rowData.documentId);
      } else if (args.commandColumn.type === "Download") {
        this.downloadDocument(args.rowData.documentId);
      }
    },
    setEditModalValues(data) {
      const addEditFormsCategoryDocumentModal = this.$refs.formsCategoryDocumentRef.$refs.AddEditFormsCategoryDocumentRef;
      const modalContent = addEditFormsCategoryDocumentModal.$children[1];
      if (modalContent) {
        modalContent.showEditFileController = true;
        modalContent.toggleFileController(false);
        modalContent.fileName = data.documentName;
        modalContent.editFileName = data.documentName;
        modalContent.documentId = data.documentId;

        addEditFormsCategoryDocumentModal.show();
      }
    },
    async downloadDocument(documentId) {
      await getDocument(documentId).then((res) => {
        window.location.href = `${res.config.baseURL}${res.config.url}`;
      });
    },
    async deleteDocument(id) {
      DialogObj = DialogUtility.confirm({
        title: "Delete Document",
        content: "Are you sure you want to delete this record?",
        position: { X: "center", Y: "top" },
        okButton: {
          text: "Yes",
          click: async () => {
            await this.$store.dispatch(DELETE_FORMS_CATEGORY_DOCUMENT, {
              id,
              category: this.$route.params.category,
            });
            this.hideDeleteDialog();
          },
        },
        cancelButton: { text: "Cancel", click: this.hideDeleteDialog },
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: "Zoom" },
      });
    },
    hideDeleteDialog() {
      DialogObj.hide();
    },
  },
};
</script>
<style>
@import "../../../../node_modules/@syncfusion/ej2-vue-popups/styles/material.css";
</style>
